import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { Button, ButtonText } from '@prisjakt/ui/button';
import { Variant } from 'src/components/button/types';

export const StyledTitle = styled(ButtonText)`
  flex-grow: 0;
`;

type ToggleButtonProps = {
  $shouldTruncate: boolean;
};

export const StyledButton = styled(Button)<ToggleButtonProps>(
  ({ $shouldTruncate }) => css`
    width: 100%;

    ${$shouldTruncate &&
      css`
        overflow: hidden;

        ${StyledTitle} {
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      `}
  `
);

type AppliedFilterCountProps = {
  buttonVariant?: Variant;
};

export const StyledAppliedFilterCount = styled.span<AppliedFilterCountProps>(
  props => css`
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    font-weight: 600;
    height: 20px;
    justify-content: center;
    margin: 0 ${layout.measurements.spacing050};
    width: 20px;

    ${props.buttonVariant !== 'outlined' &&
      css`
        background: ${props.theme.pill.inverted.bg};
        color: ${props.theme.pill.inverted.text};
      `}
  `
);
